import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import TagsListPage from "@/components/settings/tags/tags-list-page";
import { tagIdSearchSchema } from "@/lib/search/tag-id-search";

const TagsRoutePage = (): JSX.Element => {
	const { tagId } = Route.useSearch();
	return <TagsListPage deepLinkTagId={tagId} />;
};

export const Route = createFileRoute("/_app/settings/tags/")({
	validateSearch: tagIdSearchSchema,
	component: TagsRoutePage,
});
